import { render, staticRenderFns } from "./ManagerPixel.vue?vue&type=template&id=8ba4c98a&scoped=true&"
import script from "./ManagerPixel.vue?vue&type=script&lang=js&"
export * from "./ManagerPixel.vue?vue&type=script&lang=js&"
import style0 from "./ManagerPixel.vue?vue&type=style&index=0&id=8ba4c98a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ba4c98a",
  null
  
)

export default component.exports